webpackJsonp([227772203984691],{

/***/ 538:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/linkToFanPageFacebook.91300d2a.png";

/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Typography = __webpack_require__(4);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var facebookImg = __webpack_require__(538);
	var ContactoPage = function ContactoPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _Typography2.default,
	      { variant: 'display2', color: 'caption',
	        style: { color: '#3A3380', fontSize: '2rem', textAlign: 'center', fontWeight: 'bold', marginTop: '1rem' } },
	      'Contacto'
	    ),
	    _react2.default.createElement(
	      _Typography2.default,
	      { variant: 'subheading', gutterBottom: true,
	        style: { color: 'rgba(0, 0, 0, 0.54)', fontSize: '1.3rem', textAlign: 'center' } },
	      'Puede contactarse con nosotros a trav\xE9s de nuestra p\xE1gina de facebook:'
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' } },
	      _react2.default.createElement(
	        'a',
	        { href: 'https://www.facebook.com/historiArg1810/', target: '_blank' },
	        _react2.default.createElement('img', { src: facebookImg, alt: '' })
	      ),
	      _react2.default.createElement(
	        _Typography2.default,
	        { variant: 'subheading', gutterBottom: true,
	          style: { color: 'rgba(0, 0, 0, 0.54)', fontSize: '1rem' } },
	        'O por nuestro mail: historiarg@gmail.com'
	      )
	    )
	  );
	};
	
	exports.default = ContactoPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contacto-js-ba4c73f07dd7465bf2bb.js